import { createContext, useContext, useEffect, useState } from 'react';
import PageDevice from '../../page/PageDevice';
import { getRoutes } from '../../routes/getRoutes';
import { PapsContext } from './PapsContext';
import { StartContext } from './StartContext';
import { CurrentSettingsContext } from './SettingsDataContext';

export const RoutesContext = createContext();

const RoutesProvider = (props) => {

  const papsContext = useContext(PapsContext);
  const { app_state } = papsContext ?? {}

  const isMobileDevice = _.get(app_state, 'currentEnvironment.platform.isMobileDevice', false)

  // startContext
  const startContext = useContext(StartContext)
  const { start_handlers } = startContext ?? {}

  // currentSettingsContext
  const currentSettingsContext = useContext(CurrentSettingsContext)
  const { currentSettings_state } = currentSettingsContext ?? {}
  const { aps_views } = _.get(currentSettings_state, 'gvviSettings', {});

  // local state
  const [viewRoutes, setViewRoutes] = useState()
  const [genericRoutes, setGenericRoutes] = useState()

  const routes_state = { viewRoutes, genericRoutes }

  const usePageTransitions = isMobileDevice

  // IMPORTANT: Page Settings- get the settings for the page
  useEffect(() => {
    if (aps_views) {
      start_handlers.handleAmmend_useEffect('RoutesProvider')
      const { viewRoutes, genericRoutes } = getRoutes(<PageDevice />, Object.keys(aps_views).sort(), usePageTransitions)
      setViewRoutes(viewRoutes)
      setGenericRoutes(genericRoutes)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aps_views]);

  const routesProvider = () => {
    return <RoutesContext.Provider value={{ routes_state }}>
      {props.children}
    </RoutesContext.Provider>
  }

  return genericRoutes && viewRoutes ? routesProvider() : <div></div>
}

export default RoutesProvider
